import styled from 'styled-components';
import { FreeLink, pickFreeLinkSettings } from '@elfsight/widget-free-link';
import { useSettings } from '@wu/widget-core';
import { meta } from '../meta';
import { Main } from './main';

export function Widget() {
  const settings = useSettings();
  const freeLinkSettings = pickFreeLinkSettings(settings);

  return (
    <Container>
      <Main />

      <FreeLink
        {...freeLinkSettings}
        appAlias={meta.alias}
        appName={meta.name}
        style={{
          link: {
            marginTop: '20px'
          }
        }}
      />
    </Container>
  );
}

const Container = styled.div`
  position: relative;
`;
